var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec2Icon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec2Icon2",
    transform: "translate(-480 -878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4860",
    "data-name": "\\uC0AC\\uAC01\\uD615 4860",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(480 878)",
    fill: "#f2f4f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clipboard",
    transform: "translate(425.185 886.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33762",
    "data-name": "\\uD328\\uC2A4 33762",
    d: "M91.549,72.874V45.865a1.306,1.306,0,0,0-1.306-1.306H69.2a1.306,1.306,0,0,0-1.306,1.306V72.874A1.306,1.306,0,0,0,69.2,74.179H90.244A1.306,1.306,0,0,0,91.549,72.874Z",
    transform: "translate(0 -41.735)",
    fill: "#e2aa80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33763",
    "data-name": "\\uD328\\uC2A4 33763",
    d: "M394.553,44.559H392.6a1.306,1.306,0,0,1,1.306,1.306V72.874a1.306,1.306,0,0,1-1.306,1.306h1.958a1.306,1.306,0,0,0,1.306-1.306V45.865A1.306,1.306,0,0,0,394.553,44.559Z",
    transform: "translate(-304.125 -41.735)",
    fill: "#dba175"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33764",
    "data-name": "\\uD328\\uC2A4 33764",
    d: "M99.78,75.465a.979.979,0,0,0-.979.979v23.745a.979.979,0,0,0,.979.979h17.964a.979.979,0,0,0,.979-.979V76.444a.979.979,0,0,0-.979-.979Z",
    transform: "translate(-28.948 -70.683)",
    fill: "#e7ecf6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56432",
    "data-name": "\\uADF8\\uB8F9 56432",
    transform: "translate(72.144 12.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56428",
    "data-name": "\\uADF8\\uB8F9 56428",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33765",
    "data-name": "\\uD328\\uC2A4 33765",
    d: "M149.805,198.938H135.444a.49.49,0,0,1,0-.979h14.361a.49.49,0,1,1,0,.979Z",
    transform: "translate(-134.954 -197.959)",
    fill: "#407093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56429",
    "data-name": "\\uADF8\\uB8F9 56429",
    transform: "translate(0 3.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33766",
    "data-name": "\\uD328\\uC2A4 33766",
    d: "M149.805,254.568H135.444a.49.49,0,0,1,0-.979h14.361a.49.49,0,1,1,0,.979Z",
    transform: "translate(-134.954 -253.589)",
    fill: "#407093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56430",
    "data-name": "\\uADF8\\uB8F9 56430",
    transform: "translate(0 7.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33767",
    "data-name": "\\uD328\\uC2A4 33767",
    d: "M149.805,310.2H135.444a.49.49,0,1,1,0-.979h14.361a.49.49,0,1,1,0,.979Z",
    transform: "translate(-134.954 -309.219)",
    fill: "#407093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56431",
    "data-name": "\\uADF8\\uB8F9 56431",
    transform: "translate(0 10.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33768",
    "data-name": "\\uD328\\uC2A4 33768",
    d: "M149.805,365.828H135.444a.49.49,0,0,1,0-.979h14.361a.49.49,0,1,1,0,.979Z",
    transform: "translate(-134.954 -364.849)",
    fill: "#407093"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33769",
    "data-name": "\\uD328\\uC2A4 33769",
    d: "M378.448,75.465h-1.306a.326.326,0,0,1,.326.326v25.051a.326.326,0,0,1-.326.326h1.306a.979.979,0,0,0,.979-.979V76.444A.979.979,0,0,0,378.448,75.465Z",
    transform: "translate(-289.651 -70.683)",
    fill: "#d8e2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33770",
    "data-name": "\\uD328\\uC2A4 33770",
    d: "M213.94,0h-2.9a1.394,1.394,0,0,0-1.393,1.394V3.982h5.69V1.393A1.394,1.394,0,0,0,213.94,0Z",
    transform: "translate(-132.766)",
    fill: "#365e7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33771",
    "data-name": "\\uD328\\uC2A4 33771",
    d: "M253.015,0h-1.85a1.394,1.394,0,0,1,1.394,1.394V3.982h1.85V1.393A1.394,1.394,0,0,0,253.015,0Z",
    transform: "translate(-171.657)",
    fill: "#2b4d66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33772",
    "data-name": "\\uD328\\uC2A4 33772",
    d: "M167.555,35.892V32.008a.588.588,0,0,0-.588-.588H155.519a.588.588,0,0,0-.588.588v3.884a.588.588,0,0,0,.588.588h11.449A.588.588,0,0,0,167.555,35.892Z",
    transform: "translate(-81.521 -29.429)",
    fill: "#407093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33773",
    "data-name": "\\uD328\\uC2A4 33773",
    d: "M320.445,31.421H318.6a.588.588,0,0,1,.588.588v3.884a.588.588,0,0,1-.588.588h1.85a.588.588,0,0,0,.588-.588V32.008a.588.588,0,0,0-.588-.587Z",
    transform: "translate(-234.814 -29.43)",
    fill: "#365e7d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec2Icon2);
export default __webpack_public_path__ + "static/media/sec2Icon2.55127ca8584dd0ca5eec559b48be6153.svg";
export { ForwardRef as ReactComponent };